/*
 * This is just to reuse the existing, hacky, solution for my current work in implementing CIO and Segment
 * However, in a follow-up PR , I'll be completely refactoring the environment variables
 *
 * */
export const isProdEnv = () => {
  return import.meta.env.VITE_API_BASE_URL?.includes('lyka.com.au')
}
